import MActionSheet from './src';
import './style';

MActionSheet.install = Vue => {
  Vue.component('MActionSheet', MActionSheet);
};

export default MActionSheet;
